import { useTranslation } from '@egw/i18n'
import { type FC } from 'react'
import { Loader } from '../../loader/loader'

/**
 * In-progress/loading component for Plaid Multi Link flow
 */
export const PlaidInProgress: FC = () => {
  const { t } = useTranslation('features-external-accounts')

  return (
    <div
      className="flex flex-col items-center justify-center py-8"
      data-testid="plaid-multi-link-in-progress"
      role="status"
      aria-live="polite"
      aria-labelledby="loading-title"
    >
      <Loader width="revert-layer" height="2rem" />
      <p id="loading-title" className="mt-4 text-body font-semibold">
        {t('plaid_multi_link.loading_title')}
      </p>
      <p className="text-body text-sm text-center mt-2">{t('plaid_multi_link.loading_message')}</p>
    </div>
  )
}
